'use client';

interface GlobalErrorProps {
    error: Error & { digest?: string };
    reset: () => void;
}

export default function GlobalError({ reset }: GlobalErrorProps) {
    return (
        <html>
            <body>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100dvh',
                        backgroundColor: '#1a1a2e',
                        color: 'white',
                        fontFamily: 'system-ui, sans-serif',
                    }}
                >
                    <p style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem' }}>
                        Something went wrong
                    </p>
                    <button
                        onClick={() => reset()}
                        style={{
                            padding: '0.5rem 1.5rem',
                            border: '1px solid white',
                            background: 'transparent',
                            color: 'white',
                            borderRadius: '0.25rem',
                            cursor: 'pointer',
                        }}
                    >
                        Try Again
                    </button>
                </div>
            </body>
        </html>
    );
}
